import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('magma-3191-render-chin-skeleton-in-ssr') && !fg('nike_dfo_use_haschildissues_field');
	},
};
